import * as XLSX from "xlsx";
import React, { useEffect, useState } from "react";
import axios from "axios";
import Sidebar from "../Components/Sidebar";
import { MdArrowDropDown } from "react-icons/md";
import excel from "../assests/images/excel img.png";
import CreateUser from "./CreateUser";
import { Link } from "react-router-dom";
import Constant from "../Components/Utils/Constant";
import ReactPaginate from "react-paginate";
import EditUserForm from "../Components/models/EditUserForm";
import { useDispatch, useSelector } from "react-redux";
import { subscriptionRequest } from "../Redux/reducer/DataReducer";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EditModalUser from "./EditModalUser";

export default function Users() {
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  const [isDropdownOpenfilter, setIsDropdownOpenfilter] = useState(false);
  const [user, setUser] = useState([]);
  const [totalCount, setTotalCount] = useState(null);
  const [notCreatedByAdminCount, setNotCreatedByAdminCount] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const tableRef = React.createRef();
  const [showUserForm, setShowUserForm] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [showBlockConfirmation, setShowBlockConfirmation] = useState(false);
  const subscriptionRes = useSelector((state) => state?.DataReducer?.subscription);
  const dispatch = useDispatch();
  const [editPopup, setEditPopup] = useState(false);
  const [userDelete, setUserDelete] = useState(null);
  const [userToBlock, setUserToBlock] = useState(null);
  const highlightedId = useSelector((state) => state.DataReducer.highlightedId);
  const [showWatermarkConfirmation, setShowWatermarkConfirmation] = useState(false);
  const [userToChangeWatermark, setUserToChangeWatermark] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [appwatermark, setAppwatermark] = useState(null);
  const [keyStatusFilter, setKeyStatusFilter] = useState(null);
  const [isKeyStatusDropdownOpen, setIsKeyStatusDropdownOpen] = useState(false);
  const [isExpiryDropdownOpen, setIsExpiryDropdownOpen] = useState(false);
  const [sortByCreatedBy, setSortByCreatedBy] = useState(null);

  const handleOptionChange = (event, user) => {
    const selectedValue = event.target.value;
    if (selectedValue === "Edit") setEditPopup(user);
    else if (selectedValue === "Delete") handleOpenDeleteConfirmation(user._id);
    else if (selectedValue === "block") handleBlockConfirmation(user);
    else if (selectedValue === "renew") handleUpdateUser(user);
    event.target.value = "";
  };

  const handleBlockConfirmation = (user) => {
    setUserToBlock(user);
    setShowBlockConfirmation(true);
  };

  // const handleConfirmBlock = async () => {
  //   if (userToBlock) {
  //     try {
  //       const newBlockStatus = !userToBlock.block;
  //       const response = await axios.put(
  //         `${Constant.BASE_URL}/user/updatebyId`,
  //         { ...userToBlock, block: newBlockStatus }
  //       );
  //       if (response.status === 200) {
  //         setUser(
  //           user.map((u) =>
  //             u._id === userToBlock._id ? { ...u, block: newBlockStatus } : u
  //           )
  //         );
  //         toast.success(
  //           `User ${newBlockStatus ? "Blocked" : "Unblocked"} successfully!`
  //         );
  //       } else {
  //         toast.error("Failed to update user status.");
  //       }
  //     } catch (error) {
  //       toast.error("Failed to update user status.");
  //     } finally {
  //       setShowBlockConfirmation(false);
  //       setUserToBlock(null);
  //     }
  //   }
  // };


  const handleConfirmBlock = async () => {
    if (userToBlock) {
      try {
        const newBlockStatus = !userToBlock.block;
        
        // --- CHANGE IS HERE ---
        // 1. Add the user's ID to the URL
        // 2. Send ONLY the field that needs to be updated in the body
        const response = await axios.put(
          `${Constant.BASE_URL}/user/updatebyId/${userToBlock._id}`,
          { block: newBlockStatus } // More efficient payload
        );
        // --- END OF CHANGE ---

        if (response.status === 200) {
          // The rest of your function is perfect and needs no changes
          setUser(
            user.map((u) =>
              u._id === userToBlock._id ? { ...u, block: newBlockStatus } : u
            )
          );
          toast.success(
            `User ${newBlockStatus ? "Blocked" : "Unblocked"} successfully!`
          );
        } else {
          toast.error("Failed to update user status.");
        }
      } catch (error) {
        toast.error("Failed to update user status.");
      } finally {
        setShowBlockConfirmation(false);
        setUserToBlock(null);
      }
    }
  };
  const handleWatermarkChange = (user) => {
    setUserToChangeWatermark(user);
    setShowWatermarkConfirmation(true);
  };

  const handleConfirmWatermarkChange = async () => {
    if (userToChangeWatermark) {
      try {
        const newWatermarkStatus = !userToChangeWatermark.watermark;
        const response = await axios.put(
          `${Constant.BASE_URL}/user/updatebyid`,
          { ...userToChangeWatermark, watermark: newWatermarkStatus }
        );
        if (response.status === 200) {
          setUser(
            user.map((u) =>
              u._id === userToChangeWatermark._id
                ? { ...u, watermark: newWatermarkStatus }
                : u
            )
          );
          toast.success(`Watermark turned ${newWatermarkStatus ? "ON" : "OFF"}!`);
        } else {
          toast.error("Failed to change watermark status.");
        }
      } catch (error) {
        toast.error("Failed to change watermark status.");
      } finally {
        setShowWatermarkConfirmation(false);
        setUserToChangeWatermark(null);
      }
    }
  };

  const fetchUsers = async (page) => {
    try {
      let url = `${Constant.BASE_URL}/user/getUsersByAdmin1?page=${page}`;
      if (appwatermark) {
        url += `&appwatermark=${appwatermark}`;
      }
      if (keyStatusFilter) {
        url += `&status=${keyStatusFilter}`;
      }
      if (sortByCreatedBy) {
        url += `&sortBy=${sortByCreatedBy}`;
      }

      const response = await fetch(url);
      const data = await response.json();

      if (data && data.success) {
        setUser(data.admins || []);
        setTotalCount(data.totalCount);
        setTotalPages(data.totalPages);
        setNotCreatedByAdminCount(data.notCreatedByAdminCount || 0);
        setCurrentPage(page);
        dispatch(subscriptionRequest());
      }
    } catch (error) {
      console.error("Error fetching users:", error);
      setUser([]);
    }
  };

  useEffect(() => {
    fetchUsers(currentPage);
  }, [
    currentPage,
    showUserForm,
    editPopup,
    appwatermark,
    keyStatusFilter,
    sortByCreatedBy,
  ]);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected + 1);
  };

  const handleOpenDeleteConfirmation = (userId) => {
    setUserDelete(userId);
    setShowDeleteConfirmation(true);
  };

  const handleDelete = async () => {
    if (userDelete) {
      try {
        const response = await axios.delete(
          `${Constant.BASE_URL}/user/delete/${userDelete}`
        );
        if (response.status === 200) {
          setUser(user.filter((u) => u._id !== userDelete));
          toast.success("User deleted successfully");
        } else {
          toast.error("Failed to delete user");
        }
      } catch (error) {
        toast.error("Failed to delete user");
      } finally {
        setShowDeleteConfirmation(false);
        setUserDelete(null);
      }
    }
  };

  const handleSortByCreatedByClick = () => {
    setSortByCreatedBy(sortByCreatedBy ? null : 'alphabetical');
    setCurrentPage(1);
  };

  const handleCreateUserClick = () => setShowUserForm(true);
  const handleClosePopup = () => setShowUserForm(false);
  const handleUpdateUser = (user) => {
    setSelectedUser(user);
    setShowUpdateForm(true);
  };
  const handleCloseUpdateForm = () => {
    setShowUpdateForm(false);
    setSelectedUser(null);
  };
  const handleExportToExcel = () => {
    if (tableRef.current) {
      const ws = XLSX.utils.table_to_sheet(tableRef.current);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");
      XLSX.writeFile(wb, "tablexls.xlsx");
    }
  };

  return (
    <Sidebar>
      <>
        <ToastContainer position="top-right" autoClose={3000} />
        <div className="p-3 bg-grey-300 lg:p-3 xl:p-3 2xl:p-6">
          <div style={{ borderRadius: "0px 0px 11px 11px" }} className="bg-white h-[78.55vh] overflow-hidden">
            <div className="flex items-center px-4 py-3 bg-white lg:py-2 xl:py-3 2xl:py-3">
              <div className="flex-1">
                <div className="flex justify-between px-10 lg:w-full lg:px-1">
                  <div className="flex flex-wrap gap-2">
                    <div style={{ background: "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)" }} className="flex items-center justify-center px-2 bg-white rounded-sm cursor-pointer lg:w-fit 2xl:px-3 lg:py-1 xl:py-2 2xl:py-3">
                      <div className="text-5lg lg:text-[10px] xl:text-[15px] 2xl:text-[28px] font-semibold">
                        <p>Created Users : {totalCount}</p>
                      </div>
                    </div>
                    <Link to="/appcreate">
                      <div style={{ boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.25)" }} className="lg:w-fit px-2 2xl:px-3 lg:py-1 xl:py-2 2xl:py-3 cursor-pointer flex justify-center items-center bg-white rounded-sm border">
                        <div className="text-5lg lg:text-[10px] xl:text-[15px] 2xl:text-[28px] font-semibold">
                          <p>App Created Users: {notCreatedByAdminCount}</p>
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="flex-1">
                <div className="flex justify-end gap-2">
                  <div className="flex border border-white rounded-md">
                    <img onClick={handleExportToExcel} src={excel} alt="excel" className="cursor-pointer w-10 2xl:w-[80px] lg:w-[25px] xl:w-[35px]" />
                  </div>
                  <div style={{ background: "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)" }} className="lg:w-fit px-2 2xl:px-3 cursor-pointer flex justify-center items-center bg-white rounded-md border">
                    <div onClick={handleCreateUserClick} className="text-5lg lg:text-[10px] xl:text-[15px] 2xl:text-[28px] font-semibold">
                      <p>Create User</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-full overflow-hidden">
              <div className="tablebodydata overflow-auto lg:h-[65vh] xl:h-[64vh] 2xl:h-[67vh] relative">
                <table
                  ref={tableRef}
                  className="w-full divide-y divide-gray-200 table-hover table-bordered"
                  style={{ tableLayout: 'auto', minWidth: '100%' }}
                >
                  <thead className="bg-gray-100 sticky top-0 z-10">
                    <tr>
                      <th className="px-1 py-2 text-xs lg:text-[10px] xl:text-sm 2xl:text-base" style={{ width: '8%', minWidth: '80px' }}>Action</th>
                      <th className="px-1 py-2 text-xs lg:text-[10px] xl:text-sm 2xl:text-base" style={{ width: '12%', minWidth: '100px' }}>Name</th>
                      <th className="px-1 py-2 text-xs lg:text-[10px] xl:text-sm 2xl:text-base" style={{ width: '10%', minWidth: '90px' }}>Phone</th>
                      <th className="px-1 py-2 text-xs lg:text-[10px] xl:text-sm 2xl:text-base" style={{ width: '15%', minWidth: '120px' }}>Email</th>
                      <th className="px-1 py-2 text-xs lg:text-[10px] xl:text-sm 2xl:text-base" style={{ width: '8%', minWidth: '80px' }}>Coupon</th>
                      <th className="px-1 py-2 text-xs lg:text-[10px] xl:text-sm 2xl:text-base" style={{ width: '10%', minWidth: '90px' }}>
                        <div className="relative cursor-pointer">
                          <button onClick={() => setIsKeyStatusDropdownOpen(!isKeyStatusDropdownOpen)} className="flex justify-center items-center w-full focus:outline-none">
                            <p className="text-xs lg:text-[8px] xl:text-xs truncate">
                              {keyStatusFilter === 'blocked' ? 'Blocked' : "Status"}
                            </p>
                            <MdArrowDropDown className="ml-1" />
                          </button>
                          {isKeyStatusDropdownOpen && (
                            <div style={{ boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.25)", zIndex: 50 }} className="absolute top-full left-0 w-full text-center bg-white border rounded">
                              <ul>
                                <li onClick={() => { setKeyStatusFilter(null); setCurrentPage(1); setIsKeyStatusDropdownOpen(false); }} className="text-black border-t cursor-pointer hover:bg-gray-100 py-2 text-xs">All Users</li>
                                <li onClick={() => { setKeyStatusFilter("blocked"); setCurrentPage(1); setIsKeyStatusDropdownOpen(false); }} className="text-black border-t cursor-pointer hover:bg-gray-100 py-2 text-xs">Blocked</li>
                              </ul>
                            </div>
                          )}
                        </div>
                      </th>
                      <th className="px-1 py-2 text-xs lg:text-[10px] xl:text-sm 2xl:text-base" style={{ width: '8%', minWidth: '80px' }}>Last Login</th>
                      <th className="px-1 py-2 text-xs lg:text-[10px] xl:text-sm 2xl:text-base" style={{ width: '10%', minWidth: '90px' }}>
                        <div className="relative cursor-pointer">
                          <button onClick={() => setIsDropdownOpenfilter(!isDropdownOpenfilter)} className="flex justify-center items-center w-full focus:outline-none">
                            <p className="text-xs lg:text-[8px] xl:text-xs truncate">
                              {appwatermark === "true" && "W-OFF"}
                              {appwatermark === "false" && "W-ON"}
                              {appwatermark === null && "Watermark"}
                            </p>
                            <MdArrowDropDown className="ml-1" />
                          </button>
                          {isDropdownOpenfilter && (
                            <div style={{ boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.25)", zIndex: 40 }} className="absolute top-full left-0 w-full text-center bg-white border rounded">
                              <ul>
                                <li onClick={() => { setAppwatermark(null); setCurrentPage(1); setIsDropdownOpenfilter(false); }} className="text-black border-t cursor-pointer hover:bg-gray-100 py-2 text-xs">All Users</li>
                                <li onClick={() => { setAppwatermark("true"); setCurrentPage(1); setIsDropdownOpenfilter(false); }} className="text-black border-t cursor-pointer hover:bg-gray-100 py-2 text-xs">Watermark OFF</li>
                                <li onClick={() => { setAppwatermark("false"); setCurrentPage(1); setIsDropdownOpenfilter(false); }} className="text-black border-t cursor-pointer hover:bg-gray-100 py-2 text-xs">Watermark ON</li>
                              </ul>
                            </div>
                          )}
                        </div>
                      </th>
                      <th onClick={handleSortByCreatedByClick} className="px-1 py-2 cursor-pointer hover:bg-gray-200 text-xs lg:text-[10px] xl:text-sm 2xl:text-base" style={{ width: '10%', minWidth: '90px' }}>
                        <div className="flex items-center justify-center"><span className="truncate">Created By {sortByCreatedBy && ' ↕'}</span></div>
                      </th>
                      <th className="px-1 py-2 text-xs lg:text-[10px] xl:text-sm 2xl:text-base" style={{ width: '10%', minWidth: '90px' }}>
                        <div className="relative cursor-pointer">
                          <button onClick={() => setIsExpiryDropdownOpen(!isExpiryDropdownOpen)} className="flex justify-center items-center w-full focus:outline-none">
                            <p className="text-xs lg:text-[8px] xl:text-xs truncate">
                              {keyStatusFilter === 'active' && "Active"}
                              {keyStatusFilter === 'expired' && "Expired"}
                              {keyStatusFilter !== 'active' && keyStatusFilter !== 'expired' && "Key Status"}
                            </p>
                            <MdArrowDropDown className="ml-1" />
                          </button>
                          {isExpiryDropdownOpen && (
                            <div style={{ boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.25)", zIndex: 50 }} className="absolute top-full right-0 w-full text-center bg-white border rounded">
                              <ul>
                                <li onClick={() => { setKeyStatusFilter(null); setCurrentPage(1); setIsExpiryDropdownOpen(false); }} className="text-black border-t cursor-pointer hover:bg-gray-100 py-2 text-xs">All</li>
                                <li onClick={() => { setKeyStatusFilter("active"); setCurrentPage(1); setIsExpiryDropdownOpen(false); }} className="text-black border-t cursor-pointer hover:bg-gray-100 py-2 text-xs">Active</li>
                                <li onClick={() => { setKeyStatusFilter("expired"); setCurrentPage(1); setIsExpiryDropdownOpen(false); }} className="text-black border-t cursor-pointer hover:bg-gray-100 py-2 text-xs">Expired</li>
                              </ul>
                            </div>
                          )}
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {user?.map((user, index) => (
                      <tr key={user._id || index} className={index % 2 === 0 ? "bg-white" : "bg-gray-100"} style={{ background: highlightedId === user._id ? "#FFFDE7" : "" }}>
                        <td className="px-1 py-1 text-center" style={{ width: '8%' }}>
                          <select onChange={(e) => handleOptionChange(e, user)} className="text-xs py-1 px-1 border rounded shadow-sm w-full">
                            <option value="" disabled selected>Select</option>
                            <option value="Edit">Edit</option>
                            <option value="Delete">Delete</option>
                            <option value="block">{user.block ? "Unblock" : "Block"}</option>
                            {user.subscriptionexpiry && <option value="renew">Renew</option>}
                          </select>
                        </td>
                        <td className="px-1 py-1 text-xs lg:text-[10px] xl:text-sm" style={{ width: '12%' }}><div className="truncate" title={user.name}>{user.name}</div></td>
                        <td className="px-1 py-1 text-xs lg:text-[10px] xl:text-sm" style={{ width: '10%' }}><div className="truncate" title={user.phone}>{user.phone}</div></td>
                        <td className="px-1 py-1 text-xs lg:text-[10px] xl:text-sm" style={{ width: '15%' }}><div className="truncate" title={user.email}>{user.email}</div></td>
                        <td className="px-1 py-1 text-xs lg:text-[10px] xl:text-sm" style={{ width: '8%' }}><div className="truncate" title={user.cuponapplied}>{user.cuponapplied}</div></td>
                        <td className="px-1 py-1 text-center text-xs lg:text-[10px] xl:text-sm" style={{ width: '10%' }}>
                          {user.block ? (<span className="text-red-600">BLOCKED</span>) : user.subscriptionexpiry ? (<span className="text-red-600">Expired</span>) : (<span className="text-green-600">Active</span>)}
                        </td>
                        <td className="px-1 py-1 text-xs lg:text-[10px] xl:text-sm" style={{ width: '8%' }}><div className="truncate">lastlogin</div></td>
                        <td className="px-1 py-1 text-center" style={{ width: '10%' }}>
                          {/* --- IMPROVED: Changed from a select to a button for better UX --- */}
                          <button onClick={() => handleWatermarkChange(user)} className="py-1 px-2 border rounded shadow-sm text-xs w-full hover:bg-gray-100">
                            {user.watermark ? "ON" : "OFF"}
                          </button>
                        </td>
                        <td className="px-1 py-1 text-xs lg:text-[10px] xl:text-sm" style={{ width: '10%' }}><div className="truncate" title={user.createdby?.name || user.createdby || "N/A"}>{user.createdby?.name || user.createdby || "N/A"}</div></td>
                        <td className="px-1 py-1 text-xs lg:text-[10px] xl:text-sm" style={{ width: '10%', color: user.subscriptionexpiry ? "red" : "inherit" }}><div className="truncate" title={user.subscription ? user.subscription.split("T")[0] : "N/A"}>{user.subscription ? user.subscription.split("T")[0] : "N/A"}</div></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            {showUserForm && <CreateUser subscriptionRes={subscriptionRes} onClose={handleClosePopup} />}
            {showUpdateForm && <EditModalUser user={selectedUser} onClose={handleCloseUpdateForm} />}
          </div>
        </div>
        <div className="flex lg:px-4">
          <div className="w-full flex bg-white bg-white shadow-md backdrop-blur-[5.7px]">
            <div className="w-full flex items-center fixed lg:bottom-5 xl:bottom-6 2xl:bottom-6 border-t lg:text-[10px] xl:text-[14px] 2xl:text-3xl lg:pt-1 xl:pt-1 2xl:pt-0">
              <div className="flex justify-start w-full xl:px-5 2xl:p-5">
                <p className="dark:text-gray-400">Showing <span className="text-blue-500">{(currentPage - 1) * 15 + 1}</span> to <span className="text-blue-500">{Math.min(currentPage * 15, totalCount || 0)}</span> of <span className="text-yellow-500">{totalCount || 0}</span> entries</p>
              </div>
              <div className="flex justify-start pr-2 text-blue-500 pagination xl:pr-5">
                <ReactPaginate previousLabel={"<"} nextLabel={">"} breakLabel={"..."} pageCount={totalPages} forcePage={currentPage - 1} marginPagesDisplayed={1} pageRangeDisplayed={5} onPageChange={handlePageClick} containerClassName={"flex items-center space-x-2"} activeClassName={"bg-blue-500 text-white rounded-md"} pageClassName={"px-3 py-1 rounded-md hover:bg-gray-200"} previousClassName={"px-3 py-1 rounded-md hover:bg-gray-200"} nextClassName={"px-3 py-1 rounded-md hover:bg-gray-200"} />
              </div>
            </div>
          </div>
        </div>
        {editPopup && <EditUserForm subscriptionRes={subscriptionRes} editPopup={editPopup} setEditPopup={setEditPopup} />}

        {/* --- ADDED: Confirmation Modals --- */}

        {/* Delete Confirmation Modal */}
        {showDeleteConfirmation && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                <div className="bg-white p-6 rounded-lg shadow-xl w-11/12 max-w-sm">
                    <h2 className="text-lg font-bold mb-4">Confirm Deletion</h2>
                    <p className="mb-6">Are you sure you want to delete this user permanently?</p>
                    <div className="flex justify-end gap-4">
                        <button
                            onClick={() => setShowDeleteConfirmation(false)}
                            className="px-4 py-2 bg-gray-200 text-black rounded-md hover:bg-gray-300"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleDelete}
                            className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
                        >
                            Delete
                        </button>
                    </div>
                </div>
            </div>
        )}

        {/* Block/Unblock Confirmation Modal */}
        {showBlockConfirmation && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                <div className="bg-white p-6 rounded-lg shadow-xl w-11/12 max-w-sm">
                    <h2 className="text-lg font-bold mb-4">
                        {userToBlock?.block ? "Confirm Unblock" : "Confirm Block"}
                    </h2>
                    <p className="mb-6">
                        Are you sure you want to {userToBlock?.block ? "unblock" : "block"} this user?
                    </p>
                    <div className="flex justify-end gap-4">
                        <button
                            onClick={() => setShowBlockConfirmation(false)}
                            className="px-4 py-2 bg-gray-200 text-black rounded-md hover:bg-gray-300"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleConfirmBlock}
                            className={`px-4 py-2 text-white rounded-md ${
                                userToBlock?.block
                                    ? "bg-green-600 hover:bg-green-700"
                                    : "bg-red-600 hover:bg-red-700"
                            }`}
                        >
                            {userToBlock?.block ? "Unblock" : "Block"}
                        </button>
                    </div>
                </div>
            </div>
        )}
        
        {/* Watermark Confirmation Modal */}
        {showWatermarkConfirmation && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                <div className="bg-white p-6 rounded-lg shadow-xl w-11/12 max-w-sm">
                    <h2 className="text-lg font-bold mb-4">Confirm Watermark Change</h2>
                    <p className="mb-6">
                        Are you sure you want to turn the watermark {userToChangeWatermark?.watermark ? "OFF" : "ON"} for this user?
                    </p>
                    <div className="flex justify-end gap-4">
                        <button
                            onClick={() => setShowWatermarkConfirmation(false)}
                            className="px-4 py-2 bg-gray-200 text-black rounded-md hover:bg-gray-300"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleConfirmWatermarkChange}
                            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                        >
                            Confirm
                        </button>
                    </div>
                </div>
            </div>
        )}
      </>
    </Sidebar>
  );
}